import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  Divider,
  CardActions,
  Button,
  Typography,
  Avatar,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Tooltip,
  IconButton,
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import DiscussionIcon from "../../../../../assets/Images/workfellows.png";
import EditIcon from '@mui/icons-material/Edit';
import Visibility from '@mui/icons-material/Visibility';
import AssignmentsIcon from '../../../../../assets/Images/grade_book_assignments.png';
import ControlledSkelton from './ControlledSkelton';

const styles = theme => ({
  margin: {
    margin: theme.spacing(2)
  },
  extendedIcon: {
    marginRight: theme.spacing.unit
  },
  smallAvatar: {
    width: 30,
    height: 30
  },
  actions: {
    justifyContent: 'flex-end',
    textAlign: 'center'
  },
  btnText: {
    fontSize: 15,
    padding: 12,
    textTransform: 'capitalize'
  },
  bigAvatar: {
    width: 40,
    height: 40,
    marginTop: 5,
    borderRadius: 0
  }
});
const GradedDiscussion = (props) => {

  const { classes, data, isLoading } = props;

  return (
    <Card className={classes.card}>
      <CardHeader
        title={<Typography color="primary">Graded Discussion Board</Typography>}
        subheader={"Graded discussion board"}
        avatar={<Avatar className={classes.bigAvatar} src={DiscussionIcon} />}
      />
      <CardContent style={{ height: '210px' }}>
        <List style={{
          marginTop: '-30px'
        }}>

          {isLoading ? <ControlledSkelton />
            :
            data.map((dt, i) => {
              if (i < 3) {
                return (
                  <Fragment key={i}>
                    <ListItem
                      style={{ paddingTop: 0 }}
                      alignItems="flex-start"
                    >
                      <ListItemAvatar>
                        <Avatar
                          alt="Img"
                          src={AssignmentsIcon}
                          className={classes.smallAvatar}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Fragment>
                            <Typography
                              component="legend"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {dt.courseLabel}
                            </Typography>
                          </Fragment>
                        }
                        secondary={
                          <Fragment>
                            <Typography
                              variant="caption"
                              style={{ paddingLeft: "2px" }}
                            >
                              Due Date: {dt.gdaDueDate}
                            </Typography>
                          </Fragment>
                        }
                      />
                      <Tooltip title="Write Essay">
                        <IconButton
                          onClick={() => window.location.replace(`#/dashboard/graded-discussion/${dt.gdaId}`)}
                          size="large">
                          {dt.isUploaded === 1 ? <Visibility /> : <EditIcon />}
                        </IconButton>
                      </Tooltip>
                    </ListItem>
                  </Fragment>
                );
              }
            })
          }
        </List>
      </CardContent>
      <Divider variant="middle" />
      <CardActions className={classes.actions}>
        <div>
          <Tooltip title="More">
            <Button className={classes.btnText} color="primary" onClick={() => window.location = "#/dashboard/graded-discussion-reports"}>
              More
            </Button>
          </Tooltip>
        </div>
      </CardActions>
    </Card>
  );
}
GradedDiscussion.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array,
  isLoading: PropTypes.bool
}

GradedDiscussion.defaultProps = {
  data: [],
  isLoading: false
}

export default withStyles(styles)(GradedDiscussion);